import React, { useState } from 'react';
import { Button, Intent, Icon, TextArea } from '@blueprintjs/core';
import {
  Container,
  PaddingWrapper,
  DrawerHeader,
  Table,
  TableRow,
  TableHeader,
  TableData,
} from 'components/styled-components';
import styled from 'styled-components';
import map from 'lodash/map';
import filter from 'lodash/filter';
import join from 'lodash/join';
import RejectionDialog from 'components/forms/questionnaire/rejection-dialog';
import shortid from 'shortid';
import { NavigationLink } from 'components/styled-components';
import colors from 'utils/colors';
import { AppToaster } from 'components/AppToaster';
import { updatePrescreeningAnswers } from 'api/vendor-request';

import FormSelectGroup from 'components/forms/components/form-select-group';

const sameArrayValues = (a1, a2) =>{
	return (a1.filter(e => !a2.includes(e)).length === 0) && (a2.filter(e => !a1.includes(e)).length === 0) && true;
};

export const ReviewPrescreen = props => {
	const [editing, setEditing] = useState(false);
	const [updatedAnswers, updateAnswers] = useState([]);
	const [changeReason, updateChangeReason] = useState("");

	const getOriginalAnswers = () => {
		return props.instance.reduce((pt, current) => {
			return pt.concat(
				current.answers
					.filter(answer => answer.selected)
					.map(answer => answer.answerID)
			)
		},[]);
	}
	const allQuestionHaveValues = () => {
		let theAnswer = props.instance.reduce((endResult, question) => {
			if(endResult === false) return false; // if ANY are empty, return false
			return question.answers.filter(qa => updatedAnswers.includes(qa.answerID)).length > 0;
		}, true);
	
		return theAnswer
	};

	const resetAnswers = () => {
		const originalAnswers = getOriginalAnswers();
		updateAnswers(originalAnswers);
		updateChangeReason("");
		return originalAnswers;
	};
	const onChange = (selected, everything) => {
		let newAnswers = updatedAnswers
			.filter(answer => !everything.includes(answer)) //first strip all answers from this question
			.concat(selected.map(answer => answer.answerID)); // now re-add the selected ones
		updateAnswers(newAnswers);
	};
	const startEditing = () => {
		resetAnswers();
		setEditing(true);
	};
	const stopEditing = () => {
		resetAnswers();
		setEditing(false);
	};
	
	const saveAssessment = () => {
		return updatePrescreeningAnswers(props.id, updatedAnswers, changeReason)
		  .then(res => {
			AppToaster.show({
			  message: res.data.message,
			  intent: Intent.SUCCESS,
			});
		  })
		  .catch(err => {
			AppToaster.show({
			  message: err.response.data.message,
			  intent: Intent.DANGER,
			});
		  });
	  };

	const onAccept = () => {
		// check if changes
		// note: when first loading, updatedAnswers won't be filled
		if(updatedAnswers.length === 0 || sameArrayValues(getOriginalAnswers(), updatedAnswers)){
			// no changes, proceed as normal
			props.handleAccept();
		}else{
			// changes, send update API call, wait for response to continue
			saveAssessment()
				.then(res => {
					props.handleAccept();
				})
		}
	};

	return (
  <Container>
    <DrawerHeader>
      Review prescreen answers |{' '}
      {props.request &&
      props.request.vendorInformation &&
      props.request.vendorInformation
        ? props.request.vendorInformation.vendorName
        : ' '}{' '}
      - {props.request && props.request.productServiceName}
    </DrawerHeader>

    <Table>
      <tbody>
        <TableRow>
          <TableHeader>Question</TableHeader>
          <TableHeader>Answer</TableHeader>
        </TableRow>

        {map(props.instance, (entry, key) => (
          <TableRow key={shortid.generate()}>
            <TableData>{entry.question}</TableData>
            {!editing ?
				 <TableData>
					{join(filter(entry.answers, a => a.selected).map(a => a.answer), ',' )}
				</TableData>
			:
				<TableData style={{padding: "1rem 1rem 0 1rem"}}>
					<FormSelectGroup
						key={`prescreenedit-${key}`}
						value={entry.answers.filter(answer => updatedAnswers.includes(answer.answerID))}
						//   handleUpdateAnswers={this.handleUpdateAnswers}
						onChange={(a, selected) => onChange(selected, entry.answers.map(answer => answer.answerID))}
						question={entry}
						//   options={this.appendIsFixed(question.answers)}
						asyncOptions={entry.answers}
						multi={true}
						labelKey={"answer"}
						valueKey={"answerID"}
						style={{margin: "0px"}}
					/>
				</TableData>
			}
          </TableRow>
        ))}
		{!editing ? "" :
			<TableRow>
				<TableData>Reason for Change <span class="bp3-text-muted">(required)</span></TableData>
				<TableData>
					<TextArea
						value={changeReason}
						onChange={e => updateChangeReason(e.target.value)}
						fill={true}
						maxLength={500}
						minLength={1}
					/>
				</TableData>
			</TableRow>
		}
      </tbody>
    </Table>
    <PaddingWrapper
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <NavigationLink
        style={{ padding: '1.5rem' }}
        onClick={() => props.history.goBack()}
      >
        <Icon
          icon="arrow-left"
          color={colors.primary}
          iconSize={16}
          style={{ marginRight: '0.25rem' }}
        />
        <span>Back</span>
      </NavigationLink>
      <Controls>
        {/* <RejectionDialog id={props.id} handleReject={props.handleReject} /> */}
		{!editing ?
			<Button intent={Intent.WARNING} onClick={startEditing}>Change Answers</Button>
		:
			<Button intent={Intent.WARNING} onClick={stopEditing}>Cancel</Button>
		}
        <Button intent={Intent.PRIMARY} onClick={onAccept} disabled={editing && (sameArrayValues(getOriginalAnswers(), updatedAnswers) || !allQuestionHaveValues() || changeReason === "")}>
          Accept
        </Button>
      </Controls>
    </PaddingWrapper>
  </Container>
);
};

const Controls = styled.div`
  width: 18%;
  min-width: 150px;
  display: flex;
  justify-content: space-between;
  margin: 1rem;
  padding: 0.5rem;
  float: right;
`;
